// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-29838443]{width:100%}@media (min-width:960px){svg[data-v-29838443]{width:935px!important;max-width:935px!important}}", ""]);
// Exports
module.exports = exports;
